module.exports = __webpack_public_path__ + "static/img/cloudBg.51186d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cloudBg.png
// module id = qjOo
// module chunks = 2